export const ERROR_ENUM = {
  struct: {
    WITH_ERROR: 'With error',
    COM_ERRO: 'Com erro'
  },
  list: () => Object.values(ERROR_ENUM.struct)
}

export const CANCELED_ENUM = {
  struct: {
    CANCELED: 'Canceled',
    CANCELADO: 'Cancelado',
    VOIDED: 'Voided'
  },
  list: () => Object.values(CANCELED_ENUM.struct)
}

export const PARTIAL_VOID_ENUM = {
  struct: {
    PARCIAL_CANCELADO: 'Parcialmente cancelado',
    PARTIAL_VOID: 'Partial void'
  },
  list: () => Object.values(PARTIAL_VOID_ENUM.struct)
}

export const REFUNDED_ENUM = {
  struct: {
    ESTORNADO: 'Estornado',
    REFUNDED: 'Refunded'
  },
  list: () => Object.values(REFUNDED_ENUM.struct)
}

export const PARTIAL_REFUNDED_ENUM = {
  struct: {
    PARTIAL_REFUNDED: 'Partial refunded',
    PARCIAL_ESTORNADO: 'Parcialmente estornado'
  },
  list: () => Object.values(PARTIAL_REFUNDED_ENUM.struct)
}

export const CREATED_ENUM = {
  struct: {
    CREATED: 'Created',
    CRIADO: 'Criado'
  },
  list: () => Object.values(CREATED_ENUM.struct)
}

export const CAPTURED_ENUM = {
  struct: {
    CAPTURED: 'Captured',
    CAPTURADO: 'Capturado'
  },
  list: () => Object.values(CAPTURED_ENUM.struct)
}

export const AUTORIZED_PENDING_CAPTURE_ENUM = {
  struct: {
    AUTHORIZED_PENDING: 'Authorized pending capture',
    AUTORIZADO_CAPTURA: 'Autorizado captura pendente'
  },
  list: () => Object.values(AUTORIZED_PENDING_CAPTURE_ENUM.struct)
}

export const PAYMENT_PEDDING_ENUM = {
  struct: {
    PAYMENT_PEDDING: 'Payment pedding',
    AGUARDANDO_PAGAMENTO: 'Aguardando pagamento'
  },
  list: () => Object.values(PAYMENT_PEDDING_ENUM.struct)
}

export const NOT_AUTORIZED_ENUM = {
  struct: {
    NOT_AUTHORIZED: 'Not authorized',
    NAO_AUTORIZADO: 'Não autorizado'
  },
  list: () => Object.values(NOT_AUTORIZED_ENUM.struct)
}

export const FAILED_ENUM = {
  struct: {
    FAILED: 'Failed',
    FALHA: 'Falha'
  },
  list: () => Object.values(FAILED_ENUM.struct)
}

export const PAID_ENUM = {
  struct: {
    PAID: 'Paid',
    PAGO: 'Pago'
  },
  list: () => Object.values(PAID_ENUM.struct)
}

export const GENERATED_ENUM = {
  struct: {
    GENERATED: 'Generated',
    GERADO: 'Gerado'
  },
  list: () => Object.values(GENERATED_ENUM.struct)
}

export const PARTIAL_CAPTURED_ENUM = {
  struct: {
    PARTIAL_CAPTURE: 'Partial capture',
    PARCIALMENTE_CAPTURADO: 'Parcialmente capturado'
  },
  list: () => Object.values(PARTIAL_CAPTURED_ENUM.struct)
}

export const OVERPAID_ENUM = {
  struct: {
    OVERPAID: 'OverPaid',
    PAGAMAIOR: 'Paga a maior'
  },
  list: () => Object.values(OVERPAID_ENUM.struct)
}

export const UNDERPAID_ENUM = {
  struct: {
    UNDERPAID: 'Underpaid',
    PAGAMENOR: 'Paga a menor'
  },
  list: () => Object.values(UNDERPAID_ENUM.struct)
}

export const PARTIAL_WAITING_REFUND_ENUM = {
  struct: {
    WAITIN_GREFUND: 'Waiting Refund',
    AGUARDANDO_ESTORNO: 'Aguardando Estorno'
  },
  list: () => Object.values(PARTIAL_WAITING_REFUND_ENUM.struct)
}

export const ERROR_ON_VOID = {
  struct: {
    ERRO_NO_CANCELAMENTO: 'Erro no cancelamento',
    ERROR_ON_VOIDING: 'Error on voiding'
  },
  list: () => Object.values(ERROR_ON_VOID.struct)
}

export const PENDING_AUTHENTICATION = {
  struct: {
    PENDENTE_DE_AUTENTICAÇÃO: 'Pendente de autenticação',
    PENDING_AUTHENTICATION: 'Pending Authentication'
  },
  list: () => Object.values(PENDING_AUTHENTICATION.struct)
}

const hasError = statusMessage => ERROR_ENUM.list().includes(statusMessage)

const isCanceled = statusMessage => CANCELED_ENUM.list().includes(statusMessage)

const isPartialVoid = statusMessage =>
  PARTIAL_VOID_ENUM.list().includes(statusMessage)

const isRefunded = statusMessage => REFUNDED_ENUM.list().includes(statusMessage)

const isPartialRefunded = statusMessage =>
  PARTIAL_REFUNDED_ENUM.list().includes(statusMessage)

const isCreadted = statusMessage => CREATED_ENUM.list().includes(statusMessage)

const isCaptured = statusMessage => CAPTURED_ENUM.list().includes(statusMessage)

const isAutorizedPendingCapture = statusMessage =>
  AUTORIZED_PENDING_CAPTURE_ENUM.list().includes(statusMessage)

const isPaymentPedding = statusMessage =>
  PAYMENT_PEDDING_ENUM.list().includes(statusMessage)

const isNotAutorized = statusMessage =>
  NOT_AUTORIZED_ENUM.list().includes(statusMessage)

const isFailed = statusMessage => FAILED_ENUM.list().includes(statusMessage)

const isPaid = statusMessage => PAID_ENUM.list().includes(statusMessage)

const isGenerated = statusMessage =>
  GENERATED_ENUM.list().includes(statusMessage)

const isPartialCaptured = statusMessage =>
  PARTIAL_CAPTURED_ENUM.list().includes(statusMessage)

const isOverpaid = statusMessage => OVERPAID_ENUM.list().includes(statusMessage)

const isUnderpaid = statusMessage =>
  UNDERPAID_ENUM.list().includes(statusMessage)

const isPartialWaitingRefund = statusMessage =>
  PARTIAL_WAITING_REFUND_ENUM.list().includes(statusMessage)

const isErrorOnVoid = statusMessage =>
  ERROR_ON_VOID.list().includes(statusMessage)

const isPendingAuthentication = statusMessage =>
  PENDING_AUTHENTICATION.list().includes(statusMessage)

export {
  hasError,
  isCanceled,
  isPartialVoid,
  isRefunded,
  isPartialRefunded,
  isCreadted,
  isCaptured,
  isAutorizedPendingCapture,
  isPaymentPedding,
  isNotAutorized,
  isFailed,
  isPaid,
  isGenerated,
  isPartialCaptured,
  isOverpaid,
  isUnderpaid,
  isPartialWaitingRefund,
  isErrorOnVoid,
  isPendingAuthentication
}
